<template>
 <svg :width="size" :height="size">
    <LineAxis
      :key="`${index}LineAxis`"
      :point="point"
      :centerPoint="centerPoint"
      v-for="(point, index) in topPoint"
    />
    <Radar
      ref="a"
      v-for="(points, index) in spiderWebPoint"
      :key="index"
      stroke="#404040"
      opacity="0.5"
      :fill="COLORS[`primary_${MAX_SPIDER - index}`]"
      :points="points"
    />
    <Radar :points="dataPoint" fill="#729C19" opacity="0.7" />
    
    <PointValueRect
      :key="`${index}PointValueRect1`"
      :point="point"
      :index="index"
      borderRadius=4
      v-for="(point, index) in topPoint"
      :rectWidth="rectWidth"
      :rectHeight="rectHeight"
    />
    <PointValue
      :key="`${index}PointValue1`"
      :point="point"
      value="10.0"
      :index="index"
      borderRadius=4
      v-for="(point, index) in topPoint"
      :rectWidth="rectWidth"
      :rectHeight="rectHeight"
      :data="dataPoint"
    />
    <PointValueRect
      :key="`${index}PointValueRect2`"
      :point="point"
      :value="getValueWithPercent(data[index])"
      :index="index"
      borderRadius=4
      v-for="(point, index) in dataPoint"
      :rectWidth="rectWidth"
      :rectHeight="rectHeight"
    />
    <PointValue
       :key="`${index}PointValue2`"
      :point="point"
      :value="getValueWithPercent(data[index])"
      :index="index"
      borderRadius=4
      v-for="(point, index) in dataPoint"
      :rectWidth="rectWidth"
      :rectHeight="rectHeight"
      :data="dataPoint"
    />
    <PointLabel
      :key="`${index}PointLabel`"
      :point="point"
      :value="LABEL_NAME[index]"
      :actualSize="actualSize"
      :actualScore="getValueWithPercent(data[index])"
      v-for="(point, index) in topPoint"
    />
  </svg>
 
</template>
<script>

import {
  getTopPoint,
  getValueWithPercent,
  getSpiderWebPoint,
  COLORS,
  MAX_SPIDER,
  LABEL_NAME,
} from "./constant";
import Radar from "./radar.vue";
import LineAxis from "./line-axis.vue";
import PointValue from "./point-value.vue";
import PointValueRect from "./point-value-rect.vue";
import PointLabel from "./point-label.vue";

export default {
  name: "RadarChar",
  components: { Radar, LineAxis, PointValue, PointLabel, PointValueRect },
  data() {
    return { getValueWithPercent, COLORS, MAX_SPIDER, LABEL_NAME };
  },
  created() {},
  props: {
    size: String,
    data: {
      type: Array,
      default: () => [],
    },
    rectWidth: String,
    rectHeight: String,
  },
  computed: {
    actualSize() {
      return this.size - 60;
    },
    centerPoint() {
      return { x: this.size / 2, y: this.size / 2 };
    },
    topPoint() {
      return getTopPoint({
        data: this.data,
        radius: this.actualSize / 2,
        centerPoint: this.centerPoint,
      });
    },
    dataPoint() {
      return getTopPoint({
        data: this.data,
        radius: this.actualSize / 2,
        centerPoint: this.centerPoint,
        withPercent: true,
      });
    },
    spiderWebPoint() {
      return getSpiderWebPoint({
        data: this.data,
        radius: this.actualSize / 2,
        centerPoint: this.centerPoint,
      });
    },
  },
};
</script>